import axios from "axios";
import { URL } from "../config/config";

export const getAllEventService = (token) => {
  return axios.get(`${URL}event`, { headers: { "x-auth-token": token } });
};
export const getSpecificEventService = (id, token) => {
  return axios.get(`${URL}event/${id}`, { headers: { "x-auth-token": token } });
};
